<!--
 * @Version      : V1.0
 * @Date         : 2025-04-07 14:52:42
 * @fileName     : 立项详情
 * @Description  :
-->
<template>
  <el-drawer :title="title" v-loading="loading" :visible.sync="dialogDrawer" direction="rtl" :wrapperClosable="false"
    size="80%" :before-close="closeDrawer">
    <div class="details px-20 py-20 border-box">
      <el-row :gutter="20">
        <el-col :span="18">
          <descriptions v-if="!showDesc" :status="status" :row-data="rowData" :columns="columns" :span="2"
            :rules="rules" ref="descriptionsRef"></descriptions>
          <auditCom v-if="toExamine&&dialogDrawer" @refreshInitData="childReviewer"></auditCom>
        </el-col>
        <el-col :span="6">
          <div class="approval-progress">
            <div class="progress-box"  v-if="status !== 'add'">
              <div class="progress-title">审批流程</div>
              <div class="progress-desc-info flex flex-wrap">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item v-for="(item, index) in processDescInfo" :key="index">
                    <div class="items">
                      <el-avatar shape="square" size="large"
                          :src="item ? imageUrlprefix + item : defaultAvatar"></el-avatar>
                    </div>
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </div>
            <div class="progress-title" v-if="status !== 'add'">审批进度</div>
            <div class="progress-con" v-if="status !== 'add'">
              <el-timeline>
                <el-timeline-item v-for="(item, index) in processList" :key="index" size="large"
                  :icon="auditProcessStatus(item.auditStatus).icon" :color="auditProcessStatus(item.auditStatus).color">
                  <el-row :gutter="15">
                    <el-col :span="6">
                      <div>
                        <el-image v-if="item.typeLabel == '抄送人'" style="width: 40px;height: 40px;" :src="require('@/assets/makeACopyFor.png')" fit="cover"></el-image>
                        <el-avatar shape="square" v-else size="large"
                          :src="item.avatar ? imageUrlprefix + item.avatar : defaultAvatar"></el-avatar>
                      </div>
                    </el-col>
                    <el-col :span="18" v-if="item.typeLabel == '抄送人'">
                      <div class="makeACopyFor-desc">
                        <div class="makeACopyFor-title">
                          {{ item.typeLabel }}
                        </div>
                        <div class="makeACopyFor-num">
                          已抄送{{ item.userList ? item.userList.length : 0 }}人
                        </div>
                        <div class="makeACopyFor-box flex justify-start items-center flex-wrap">
                          <div class="child-items" v-for="(cItem, cIndex) in item.userList" :key="cIndex">
                            <el-avatar shape="square" size="large"
                              :src="cItem.userAvatar ? imageUrlprefix + cItem.userAvatar : defaultAvatar"></el-avatar>
                            <div class="child-text">{{ cItem.userName }}</div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="18" v-else>
                      <div class="progress-desc">
                        <div><span>{{ item.name }}</span><span class="progress-time">{{ item.date }}</span></div>
                        <div>{{ item.typeLabel }}</div>
                        <div :style="{ color: auditProcessStatus(item.auditStatus).color, fontSize: '18px' }">{{
                          item.auditLabel }}</div>
                        <div class="signature-box flex justify-start items-center" v-if="item.signatureUrl">
                          <span class="signature-title">签名</span>
                          <el-image class="signature-img" :src="imageUrlprefix + item.signatureUrl"
                            fit="contain"></el-image>
                        </div>
                        <el-tooltip class="item" effect="dark" :content="item.auditComment" placement="top-start">
                          <p class="notes-text" v-if="item.auditStatus == 2 || item.auditStatus == 9">
                            {{ item.auditComment }}
                          </p>
                        </el-tooltip>
                      </div>
                    </el-col>
                  </el-row>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="details-footer px-20 py-20 border-box" v-if="status !== 'view'">
      <el-button type="primary" @click="submit()">提交</el-button>
      <el-button type="primary" @click="temporarilyStore()">暂存</el-button>
      <el-button @click="clearForm()">清空</el-button>
    </div>
  </el-drawer>
</template>

<script>
import descriptions from '@/components/descriptions/index.vue'
import { projecDetailstApi, addProjectApi, editProjectApi, processProjectApi, changeProjectApi,queryAuditProcessDescriptionApi } from '@/api/project/index'
import { querySupplierInfoListApi, queryBasicOwnersListApi, queryChargeListtApi } from '@/api/basicInfo/index'
import { auditProcessStatus } from '@/utils/index'
import { dataPage } from "@/api/sys/dictData";
import auditCom from "@/components/auditCom/index.vue"
export default {
  components: {
    descriptions,
    auditCom
  },
  props: {
    toExamine: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '我方主体详情'
    },
    status: {
      type: String,
      default: 'view'
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value && /^1[3456789]\d{9}$/.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确的手机号码'))
      }
    }
    return {
      defaultAvatar: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
      dialogDrawer: false,
      loading: false,
      customerForm: {},
      showDesc: false,
      columns: [
        { key: 'projectCode', label: '项目编号', span: 2, placeholder: '请输入项目编号', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'projectName', label: '项目名称', span: 1, placeholder: '客户名称+业务描述', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'projectTypeCode', label: '项目类型', span: 1, placeholder: '请选择项目类型', input: 'select', type: 'text', disabled: true, defaultValue: '', option: [], labelKey: 'dictLabel', valueKey: 'dictValue' },
        { key: 'startDate', label: '项目开始日期', span: 1, placeholder: '请选择项目开始日期', input: 'date', type: '', disabled: true, defaultValue: '' },
        { key: 'endDate', label: '项目结束日期', span: 1, placeholder: '请选择项目结束日期', input: 'date', type: '', disabled: true, defaultValue: '' },
        { key: 'customerId', label: '选择客户', span: 2, placeholder: '请选择客户', input: 'select', type: 'text', disabled: true, defaultValue: '', option: [], labelKey: 'customerName', valueKey: 'id' },
        { key: 'customerChargePerson', label: '客户负责人', span: 1, placeholder: '请输入客户负责人', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'customerContactPhone', label: '客户联系电话', span: 1, placeholder: '请输入客户联系电话', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'ownerId', label: '我方单位', span: 1, placeholder: '请选择我方单位', input: 'select', type: 'text', disabled: true, defaultValue: '', option: [], labelKey: 'unitName', valueKey: 'id' },
        { key: 'ownerChargePersonId', label: '我方负责人', span: 1, placeholder: '请选择我方负责人', input: 'select', type: 'text', disabled: true, defaultValue: '', labelKey: 'name', valueKey: 'id' },
        { key: 'projectDurationDays', label: '项目期限(天)', span: 1, placeholder: '开始日期-结束日期', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'estimatedAmount', label: '预计项目金额(元)', span: 2, placeholder: '请输入预计项目金额', input: 'input-number', type: 'text', disabled: true, defaultValue: 0 },
        { key: 'attachment', height: '450px', label: '附件', span: 2, placeholder: '请上传附件上传', uploadType: 'project', input: 'upload', fileMaxSize: 200, disabled: true, defaultValue: [], accept: '.xls,.xlsx,.pdf,.doc,.docx,.txt,.bmp,.jpg,.jpeg,.png,.tif,.gif,.svg,.webp,.zip,.rar,.7z', limit: 50, },
        { key: 'notes', label: '备注', span: 2, placeholder: '请输入备注', input: 'textarea', type: 'textarea', disabled: true, defaultValue: '' },
      ],
      rowData: {},
      cloneColumns: [],//复制一遍
      rules: {
        projectCode: [
          { required: true, message: '请输入项目编号', trigger: 'blur' },
        ],
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
        ],
        projectTypeCode: [
          { required: true, message: '请选择项目类型', trigger: 'change' }
        ],
        startDate: [
          { type: 'string', required: true, message: '请选择项目开始日期', trigger: 'change' }
        ],
        endDate: [
          { type: 'string', required: true, message: '请选择项目结束日期', trigger: 'change' }
        ],
        customerId: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        customerChargePerson: [
          { required: true, message: '请输入客户负责人', trigger: 'blur' }
        ],
        customerContactPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        ownerId: [
          { required: true, message: '请选择我方单位', trigger: 'change' }
        ],
        ownerChargePersonId: [
          { required: true, message: '请选择我方负责人', trigger: 'change' }
        ]
      },
      processList: [],
      processDescInfo:[]
    }
  },
  mounted() {
    this.getCurtomer();
    this.dictOption();
    this.getOwnersList();
    this.getChargeList()
    this.cloneColumns = JSON.parse(JSON.stringify(this.columns))
  },
  methods: {
    auditProcessStatus,
    //核心方法 判断是否是新增 还是编辑
    async openDrawer(row) {
      this.dialogDrawer = true;
      this.$nextTick(() => {
        switch (this.status) {
          case 'view':
            this.queryDetails({ id: row.id })
            break;
          case 'add':
            //新增把原有的数据设置默认值
            this.showDesc = true;
            for (let i = 0; i < this.columns.length; i++) {
              this.columns[i].disabled = false;
              this.columns[i].defaultValue = this.cloneColumns[i].defaultValue;
            }
            this.$nextTick(() => {
              this.showDesc = false;
            })
            break;
          case 'edit':
            this.queryDetails({ id: row.id })
            break;
          case 'change':
            this.queryDetails({ id: row.id })
            break;
          default:
            break;
        }
      })
    },
    //关闭弹框
    closeDrawer() {
      this.dialogDrawer = false;
    },
    //详情查询
    queryDetails(params) {
      this.loading = true;
      this.showDesc = true;
      projecDetailstApi(params).then(res => {
        this.loading = false;
        this.showDesc = false;
        if (res.code == 200) {
          this.rowData = res.data;
          if (this.status !== 'add') {
            for (let i = 0; i < this.columns.length; i++) {
              this.columns[i].disabled = this.status == 'view' ? true : false;
              this.columns[i].defaultValue = this.rowData[this.columns[i].key];
            }
          }
        }
      })
      this.queryProcessProject(params)
      this.qeuryAuditProcessDescription(params)
    },
    //提交
    submit(status = 1) {
      this.$refs.descriptionsRef.submit().then(formData => {
        let params = {
          projectStatus: status,
          ...formData
        }
        this.loading = true;
        if (this.status == 'add') {
          addProjectApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          })
        } else if (this.status == 'change') {
          changeProjectApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          }).catch(err => {
            this.loading = false;
          })
        } else {
          editProjectApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          }).catch(err => {
            this.loading = false;
          })
        }

      })
    },
    //暂存
    temporarilyStore() {
      this.submit(0);
    },
    //清空描述组件form
    clearForm() {
      this.$refs.descriptionsRef.resetForm()
    },
    //查询列表
    queryData() {
      this.$emit('initQueryData')
    },
    //获取客户档案
    getCurtomer() {
      let params = {
        customerName: ""
      }
      querySupplierInfoListApi(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'customerId') {
              item.option = res.data || []
            }
            return item
          })
        }
      })
    },
    async dictOption() {
      let params = {
        query: {
          dictType: 'project_type'
        }
      }
      dataPage(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'projectTypeCode') {
              item.option = res.data.rows || []
            }
            return item
          })
        }
      })
    },
    //我方负责单位下拉
    getOwnersList() {
      let params = {
        unitName: ""
      }
      queryBasicOwnersListApi(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'ownerId') {
              item.option = res.data || []
            }
            return item
          })
        }
      })
    },
    //我方负责人下拉
    getChargeList() {
      let params = {}
      queryChargeListtApi(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'ownerChargePersonId') {
              item.option = res.data || []
            }
            return item
          })
        }
      })
    },
    queryProcessProject(params) {
      processProjectApi(params).then(res => {
        if (res.code == 200) {
          this.processList = res.data;
        }
      })
    },
    //刷新页面
    childReviewer(row) {
      this.closeDrawer()
      this.$emit('parReviewer')
    },
    qeuryAuditProcessDescription(params){
      queryAuditProcessDescriptionApi(params).then(res=>{
        if(res.code==200){
          this.processDescInfo = res.data.avatars;
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">

::v-deep .el-drawer__header {
  color: #000;
  font-size: 18px;
}
::v-deep .el-breadcrumb__separator{
  color: #000;
}

.details-footer {
  height: 50px;
  line-height: 50px;
  text-align: right;
}

.progress-box{
  padding: 5px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  border-radius: 5px;
  margin-bottom: 5px;
  background: #285af1;
  .progress-title {
    font-size: 18px;
    padding-bottom: 10px;
    color: #fff;
  }
  .progress-desc-info {
    padding: 10px 0px 10px 0px;

    .items {
      font-size: 15px;
      display: inline-block;
      vertical-align: middle; 
    }
  }
}
.approval-progress {
  .progress-desc-info{
    padding:10px 0px 10px 0px;
    .items{
      font-size: 15px;
      color: #285af1;
    }
  }
  .progress-title {
    font-size: 18px;
    padding-bottom: 10px;
  }

  .progress-con {
    .progress-desc {
      line-height: 20px;
      color: #303133;

      .progress-time {
        margin-left: 10px;
        color: #909399;
      }

      .notes-text {
        display: -webkit-box;
        /* 设置为弹性盒子模型 */
        -webkit-box-orient: vertical;
        /* 垂直排列 */
        -webkit-line-clamp: 2;
        /* 显示最多 3 行 */
        overflow: hidden;
        /* 隐藏超出的部分 */
        text-overflow: ellipsis;
        /* 使用省略号 */
      }

      .signature-box {
        width: 180px;
        height: 50px;
        overflow: hidden;

        .signature-title {
          display: block;
          width: 40px;
        }

        .signature-img {
          margin-left: 10px;
          width: 180px;
        }
      }
    }

    .makeACopyFor-desc {
      line-height: 20px;
      color: #303133;

      .makeACopyFor-title {}

      .makeACopyFor-num {
        color: #909399;
      }

      .makeACopyFor-box {
        .child-items {
          padding-right: 5px;
          box-sizing: border-box;

          .child-text {
            text-align: center;
          }
        }
      }
    }
  }
}



</style>
